export const TypeInteractive = {
  test: 'test',
  vote: 'vote',
  link: 'link',
  testResult: 'testResult',
  voteResult: 'voteResult',
  votesGroup: 'votesGroup',
  votesRatingGroup: 'votesRatingGroup',
  voteRating: 'voteRating',
  voteRatingResult: 'voteRatingResult',
  rating: 'rating',
};
